export const APPS = [
  {
    slug: "parole-in-coda",
    name: "Parole in Coda",
    category: { it: "Giochi di parole", en: "Word Games" },
    tagline: { it: "Il gioco di parole a catena", en: "The chain word game" },
    accent: "#2DD4BF",
    version: "1.2.3",
    size: "89,0 MB",
    age: "4+",
    price: { it: "Gratis · Acquisti in-app", en: "Free · In-App Purchases" },
    storeUrl: "https://apps.apple.com/it/app/parole-in-coda/id6801831622",
    playUrl: "https://play.google.com/store/apps/details?id=com.emergent.wordchaingame.fcmw94",
    comingSoon: false,
    icon: "/assets/parole-in-coda-icon.webp",
    screenshots: [
      "/assets/parole-in-coda/shot-01.webp",
      "/assets/parole-in-coda/shot-02.webp",
      "/assets/parole-in-coda/shot-03.webp",
      "/assets/parole-in-coda/shot-04.webp",
      "/assets/parole-in-coda/shot-05.webp",
      "/assets/parole-in-coda/shot-06.webp",
      "/assets/parole-in-coda/shot-07.webp",
      "/assets/parole-in-coda/shot-08.webp",
    ],
    intro: {
      it: "La parola successiva deve iniziare con le ULTIME DUE LETTERE di quella precedente. Facile da capire, difficilissimo da smettere. Da solo o con amici: semplice, veloce, divertente e istruttivo — in ogni partita impari parole nuove, senza bisogno di registrarti.",
      en: "The next word must start with the LAST TWO LETTERS of the previous one. Easy to learn, impossibly hard to put down. Solo or with friends: simple, fast, fun and educational — every match teaches you new words, no sign-up needed.",
    },
    details: {
      it: [
        "Ogni partita è tua: puoi modificare le categorie esistenti e crearne di nuove, così il gioco si adatta a chi è al tavolo con te — dai bambini agli amici più competitivi. Cambi le regole, cambia la sfida.",
        "Quando giochi da solo non ti annoi mai: la difficoltà della CPU si adatta al tuo livello. Più vinci, più l'avversario artificiale diventa abile nel trovare parole lunghe e rare, per partite sempre in equilibrio.",
        "Nella schermata delle statistiche trovi la cronologia delle tue partite, i tuoi record per ogni modalità e la parola più lunga che sei riuscito a trovare: l'avversario più difficile da battere sei tu, una lettera alla volta.",
        "Per le serate in compagnia c'è la modalità torneo: apri il tabellone su un tablet e tutti i partecipanti vedono accoppiamenti e partite in corso aggiornarsi in tempo reale, come in una vera competizione.",
      ],
      en: [
        "Every match is yours: you can edit the existing categories and create new ones, so the game adapts to whoever is at the table with you — from kids to your most competitive friends. Change the rules, change the challenge.",
        "Playing solo never gets boring: the CPU difficulty adapts to your level. The more you win, the better the artificial opponent becomes at finding long and rare words, keeping every match balanced.",
        "The stats screen shows your match history, your records for every mode and the longest word you managed to find: the hardest opponent to beat is yourself, one letter at a time.",
        "For game nights there's tournament mode: open the bracket board on a tablet and every participant sees pairings and ongoing matches update in real time, just like a real competition.",
      ],
    },
    features: [
      {
        title: { it: "Tante modalità di gioco", en: "Many game modes" },
        items: {
          it: ["Classica — costruisci la catena più lunga in 3 minuti", "Infinita — senza limite di tempo, un solo errore possibile", "Scelta Crudele — 2, 3 o 4 lettere: più lettere, più punti", "Passa il Telefono — multiplayer locale fino a 6 giocatori", "Categorie — 10 temi che cambiano a ogni parola", "Sfida CPU — tre livelli di difficoltà", "Sfida Giornaliera — una parola nuova ogni giorno"],
          en: ["Classic — build the longest chain in 3 minutes", "Endless — no time limit, one mistake only", "Cruel Choice — 2, 3 or 4 letters: more letters, more points", "Pass the Phone — local multiplayer up to 6 players", "Categories — 10 themes that change every word", "CPU Challenge — three difficulty levels", "Daily Challenge — a new word every day"],
        },
      },
      {
        title: { it: "Sfida online 1 contro 1", en: "Online 1v1 battles" },
        items: {
          it: ["Gioca contro un amico ovunque nel mondo: crea una partita e condividi il codice o il QR", "Catena condivisa a turni alternati", "Gara a punti da 3 minuti: chi fa più punti vince", "Limite di tempo opzionale da 10, 20 o 30 secondi a parola"],
          en: ["Play a friend anywhere in the world: create a match and share the code or QR", "Shared chain with alternating turns", "3-minute point race: highest score wins", "Optional 10, 20 or 30 second per-word timer"],
        },
      },
      {
        title: { it: "Scopri il significato", en: "Discover meanings" },
        items: {
          it: ["Tocca la lente vicino alla parola per leggerne la definizione", "Quando perdi, scopri quale parola avresti potuto giocare", "Gioca e impara ogni giorno qualcosa di nuovo"],
          en: ["Tap the lens next to a word to read its definition", "When you lose, discover the word you could have played", "Play and learn something new every day"],
        },
      },
      {
        title: { it: "Perché ti piacerà", en: "Why you'll love it" },
        items: {
          it: ["In italiano o in inglese, con ricchi dizionari integrati", "Nessuna registrazione: apri e gioca", "Funziona offline (le partite online richiedono internet)", "Classifiche e obiettivi con Game Center", "Statistiche e record salvati sul dispositivo", "Rimuovi la pubblicità con un unico acquisto"],
          en: ["Italian or English, with rich built-in dictionaries", "No sign-up: open and play", "Works offline (online matches need internet)", "Game Center leaderboards and achievements", "Stats and records stored on your device", "Remove ads with a single purchase"],
        },
      },
    ],
    changelog: {
      version: "1.2.3",
      it: ["CATEGORIE SU MISURA — scegli quali categorie usare prima di iniziare", "CAMBIO IN CORSO — durante il gioco puoi cambiare categoria fino a 3 volte a partita", "IMPORTA ED ESPORTA — crea e condividi nuove categorie, anche in formato txt"],
      en: ["CUSTOM CATEGORIES — choose which categories to use before you start", "SWITCH MID-GAME — change category up to 3 times per match while playing", "IMPORT & EXPORT — create and share new categories, also in txt format"],
    },
    roadmap: null,
  },
  {
    slug: "cifroo",
    name: "Cifroo",
    category: { it: "Puzzle matematici", en: "Math Puzzles" },
    tagline: { it: "Ogni operazione conta!", en: "Every move counts!" },
    accent: "#8B7CFF",
    version: "1.1.1",
    size: "87,7 MB",
    age: "12+",
    price: { it: "Gratis", en: "Free" },
    storeUrl: "https://apps.apple.com/it/app/cifroo/id6807161892",
    playUrl: "https://play.google.com/store/apps/details?id=com.emergent.createmobileapp.gb6z9o",
    comingSoon: false,
    demo: true,
    icon: "/assets/cifroo-icon.webp",
    banner: "/assets/cifroo/banner.webp",
    screenshots: [
      "/assets/cifroo/shot-01.webp",
      "/assets/cifroo/shot-02.webp",
      "/assets/cifroo/shot-03.webp",
      "/assets/cifroo/shot-04.webp",
      "/assets/cifroo/shot-05.webp",
      "/assets/cifroo/shot-06.webp",
      "/assets/cifroo/shot-07.webp",
      "/assets/cifroo/shot-08.webp",
    ],
    intro: {
      it: "Tocca una tessera, poi un'operazione, poi un'altra tessera: somma, sottrai, moltiplica o dividi e raggiungi il numero bersaglio. Facile da imparare, difficile da mollare. Allenati in solitaria, sfida la CPU, gioca la Sfida del Giorno oppure organizza un vero torneo con i tuoi amici.",
      en: "Tap a tile, then an operation, then another tile: add, subtract, multiply or divide to reach the target number. Easy to learn, hard to put down. Train solo, challenge the CPU, play the Daily Challenge or run a real tournament with your friends.",
    },
    details: {
      it: [
        "Il cuore competitivo di Cifroo sono i tornei. Con il Torneo Svizzero organizzi una competizione tra amici in pochi secondi: crei il torneo, condividi il codice e l'app gestisce abbinamenti, turni e classifica a punti in automatico. E chi non gioca può fare da Regia: un dispositivo dedicato mostra bracket e risultati in tempo reale e fa avanzare i turni, perfetto da lasciare sul tavolo durante la serata.",
        "All'inizio di ogni partita puoi alzare la posta: scarta uno dei numeri iniziali e otterrai un bonus in percentuale sui punti. Ma attenzione — con una tessera in meno, il bersaglio potrebbe diventare impossibile da raggiungere. Rischiare il bonus o giocare sul sicuro? È qui che Cifroo smette di essere solo un gioco di calcolo e diventa un gioco di strategia.",
        "Ogni giorno c'è un motivo per tornare: la Sfida del Giorno propone lo stesso puzzle a tutti i giocatori, una sola prova e niente secondi tentativi. Completando i livelli del percorso guadagni stelle e sblocchi nuove skin del tabellone.",
      ],
      en: [
        "Tournaments are Cifroo's competitive heart. With the Swiss Tournament you can set up a competition with friends in seconds: create the tournament, share the code and the app handles pairings, rounds and the points leaderboard automatically. And anyone not playing can act as Director: a dedicated device shows brackets and results in real time and advances the rounds — perfect to leave on the table during game night.",
        "At the start of every match you can raise the stakes: discard one of your starting numbers and you'll get a percentage bonus on your points. But beware — with one tile fewer, the target may become impossible to reach. Risk the bonus or play it safe? That's where Cifroo stops being just a math game and becomes a game of strategy.",
        "Every day there's a reason to come back: the Daily Challenge offers the same puzzle to every player, one single attempt and no second chances. Completing journey levels earns you stars and unlocks new board skins.",
      ],
    },
    features: [
      {
        title: { it: "Come si gioca", en: "How to play" },
        items: {
          it: ["Combina due numeri con +, −, × o ÷ per avvicinarti al bersaglio", "Tre difficoltà: Facile, Medio e Difficile", "Un percorso di 50 livelli da completare", "Guadagna stelle e sblocca nuove skin del tabellone"],
          en: ["Combine two numbers with +, −, × or ÷ to get closer to the target", "Three difficulties: Easy, Medium and Hard", "A 50-level journey to complete", "Earn stars and unlock new board skins"],
        },
      },
      {
        title: { it: "Tante modalità", en: "Many modes" },
        items: {
          it: ["Gioca — allenati e batti il tuo record", "Sfida CPU — batti l'avversario artificiale", "Sfida del Giorno — lo stesso puzzle per tutti, una sola prova", "Sfida un amico — lo stesso puzzle, con un codice da condividere"],
          en: ["Play — train and beat your record", "CPU Challenge — beat the artificial opponent", "Daily Challenge — the same puzzle for everyone, one single attempt", "Challenge a friend — the same puzzle, with a code to share"],
        },
      },
      {
        title: { it: "Torneo Svizzero", en: "Swiss Tournament" },
        items: {
          it: ["Crea un torneo tra amici e condividi il codice", "Classifica a punti con regolamento Svizzero", "Scegli la difficoltà del torneo: Facile, Medio o Difficile", "Modalità Regia: mostra bracket e risultati in tempo reale e avanza i turni"],
          en: ["Create a tournament with friends and share the code", "Points leaderboard with Swiss-system rules", "Pick the tournament difficulty: Easy, Medium or Hard", "Director mode: show brackets and live results and advance the rounds"],
        },
      },
      {
        title: { it: "Perché ti piacerà", en: "Why you'll love it" },
        items: {
          it: ["Nessuna registrazione: apri e gioca", "Classifica globale per le partite classificate", "In italiano e in inglese", "Gratuita"],
          en: ["No sign-up: open and play", "Global leaderboard for ranked matches", "In Italian and English", "Free"],
        },
      },
    ],
    changelog: {
      version: "1.1.1",
      it: ["Obiettivi e classifica su Game Center", "Nuovi livelli segreti per chi completa tutti gli obiettivi"],
      en: ["Game Center achievements and leaderboard", "New secret levels for those who complete every achievement"],
    },
    roadmap: null,
  },
  {
    slug: "cthulhu-tracker",
    name: "Cthulhu Tracker",
    category: { it: "Giochi di ruolo", en: "Role Playing" },
    tagline: { it: "Il compagno definitivo per il Richiamo di Cthulhu", en: "The ultimate Call of Cthulhu companion" },
    accent: "#C9A227",
    version: "1.4.1",
    size: "158,8 MB",
    age: "4+",
    price: { it: "Gratis · Acquisti in-app", en: "Free · In-App Purchases" },
    storeUrl: "https://apps.apple.com/it/app/cthulhu-tracker/id6800874026",
    playUrl: "https://play.google.com/store/apps/details?id=com.emergent.cthulhukeeper.x3fjk0",
    comingSoon: false,
    icon: "/assets/cthulhu-tracker-icon.webp",
    screenshots: [
      "/assets/cthulhu-tracker/shot-01.webp",
      "/assets/cthulhu-tracker/shot-02.webp",
      "/assets/cthulhu-tracker/shot-03.webp",
      "/assets/cthulhu-tracker/shot-04.webp",
      "/assets/cthulhu-tracker/shot-05.webp",
      "/assets/cthulhu-tracker/shot-06.webp",
      "/assets/cthulhu-tracker/shot-07.webp",
      "/assets/cthulhu-tracker/shot-08.webp",
      "/assets/cthulhu-tracker/shot-09.webp",
      "/assets/cthulhu-tracker/shot-10.webp",
    ],
    intro: {
      it: "Il perfetto supporto per scenari, oneshot e campagne ambientate nel mondo creato da Lovecraft: gestisci schede, tiri e orrore cosmico dal telefono, con sincronizzazione dal vivo tra il Custode e i Giocatori. Che tu stia guidando un'indagine o interpretando un investigatore, tutto ciò che ti serve al tavolo è a portata di mano.",
      en: "The perfect companion for scenarios, one-shots and campaigns set in Lovecraft's world: manage sheets, rolls and cosmic horror from your phone, with live sync between the Keeper and the Players. Whether you're running an investigation or playing an investigator, everything you need at the table is at hand.",
    },
    details: {
      it: [
        "Cthulhu Tracker nasce al tavolo da gioco: schede investigatore complete di caratteristiche, abilità, equipaggiamento e incantesimi, tiri di dado integrati e gestione di sanità, magia e fortuna. Tutto quello che di solito copre il tavolo di carta e matite, raccolto in un'unica app.",
        "Durante la sessione il Custode condivide indizi, immagini e documenti PDF con i Giocatori in tempo reale, e ogni tiro di dado appare istantaneamente sui dispositivi di tutti i partecipanti. Le campagne restano salvate sul tuo account: chiudi l'app a fine serata e riprendi esattamente da dove eri rimasto.",
        "E non è finita: l'app gestisce anche la ricarica delle armi durante i combattimenti, i tiri di sanità con i relativi effetti di pazzia temporanea o indefinita, la chat in tempo reale tra Giocatore e Custode e le note — personali o condivise — legate alla sessione. E molto altro ancora.",
      ],
      en: [
        "Cthulhu Tracker was born at the game table: complete investigator sheets with characteristics, skills, equipment and spells, integrated dice rolls and tracking for sanity, magic and luck. Everything that usually covers the table with paper and pencils, gathered in a single app.",
        "During the session the Keeper shares handouts, images and PDF documents with the Players in real time, and every dice roll appears instantly on everyone's devices. Campaigns stay saved on your account: close the app at the end of the evening and pick up exactly where you left off.",
      ],
    },
    features: [
      {
        title: { it: "Investigatori", en: "Investigators" },
        items: {
          it: ["Creazione guidata della scheda, con professioni predefinite e personalizzate", "Caratteristiche, abilità, specializzazioni e bonus danno", "Punti Ferita, Punti Magia, Sanità e Fortuna sempre aggiornati", "Battito cardiaco che accelera con le ferite gravi", "Grimorio degli incantesimi"],
          en: ["Guided character creation with preset and custom occupations", "Characteristics, skills, specializations and damage bonus", "Hit Points, Magic Points, Sanity and Luck always up to date", "Heartbeat that speeds up with serious wounds", "Spell grimoire"],
        },
      },
      {
        title: { it: "Dadi e prove", en: "Dice & checks" },
        items: {
          it: ["Dadi 3D più grandi e leggibili, con sfondi d'atmosfera durante il lancio", "Tiri 1d100 con difficoltà Normale, Ardua ed Estrema, critico e catastrofe", "Tiro del danno delle armi con Bonus al Danno incluso", "Dadi bonus e penalità", "Il Custode lancia prove e danni direttamente dalla scheda dell'investigatore"],
          en: ["Bigger, more readable 3D dice with atmospheric backgrounds", "1d100 rolls with Normal, Hard and Extreme difficulty, criticals and fumbles", "Weapon damage rolls with Damage Bonus included", "Bonus and penalty dice", "The Keeper rolls checks and damage straight from the investigator's sheet"],
        },
      },
      {
        title: { it: "Il tavolo del Custode", en: "The Keeper's table" },
        items: {
          it: ["Monitoraggio in tempo reale di tutti gli investigatori", "Tracker di iniziativa e combattimento, con PNG e attacchi multipli", "Applica danni, gestisci la Sanità e assegna i Miti di Cthulhu", "Effetti di follia temporanea generati automaticamente", "Distribuzione di indizi e handout", "Storico della sessione esportabile in PDF"],
          en: ["Real-time monitoring of every investigator", "Initiative and combat tracker, with NPCs and multiple attacks", "Apply damage, manage Sanity and award Cthulhu Mythos", "Automatically generated temporary insanity effects", "Hand out clues and handouts", "Session history exportable to PDF"],
        },
      },
      {
        title: { it: "Cataloghi e sincronizzazione", en: "Catalogs & live sync" },
        items: {
          it: ["Professioni, armi, oggetti e incantesimi personalizzati", "Ricerca rapida e libreria di pregenerati", "Ritratto di gruppo con cornici d'epoca, da salvare o condividere", "Glossario italiano-inglese e nomi originali inglesi per abilità e caratteristiche", "Ogni modifica del Custode appare all'istante sulle schede dei Giocatori", "Accesso con Apple e Google"],
          en: ["Custom occupations, weapons, items and spells", "Quick search and a library of pregenerated characters", "Group portrait with vintage frames, to save or share", "Italian-English glossary and original English names for skills and characteristics", "Every Keeper change appears instantly on the Players' sheets", "Sign in with Apple and Google"],
        },
      },
    ],
    changelog: {
      version: "1.4.1",
      it: ["Tiro di dadi anche per il Custode, con tiri contrapposti automatici", "Migliore gestione delle immagini condivise durante la sessione", "Consumo di batteria ridotto grazie all'uso ottimizzato dei modelli 3D dei dadi", "Correzioni grafiche"],
      en: ["Dice rolls for the Keeper too, with automatic opposed rolls", "Improved handling of images shared during the session", "Reduced battery consumption thanks to optimised 3D dice models", "Graphical fixes"],
    },
    roadmap: null,
    disclaimer: {
      it: "Il Richiamo di Cthulhu / Call of Cthulhu è un marchio di Chaosium Inc. Questa è un'applicazione non ufficiale, pensata come strumento per i giocatori, non affiliata né approvata da Chaosium Inc.",
      en: "Call of Cthulhu is a trademark of Chaosium Inc. This is an unofficial application, designed as a tool for players, not affiliated with nor endorsed by Chaosium Inc.",
    },
  },
  {
    slug: "simple-and-fast",
    name: "Simple and Fast",
    category: { it: "Giochi di ruolo", en: "Role Playing" },
    tagline: { it: "Il mio gioco di ruolo originale, in un'app", en: "My original tabletop RPG, in an app" },
    accent: "#E5484D",
    version: null,
    size: null,
    age: null,
    price: { it: "Gratis · Sblocco Master 9,99 €", en: "Free · Master unlock €9.99" },
    storeUrl: null,
    comingSoon: true,
    icon: "/assets/simple-and-fast/icon.webp",
    banner: "/assets/simple-and-fast/banner.webp",
    screenshots: [
      "/assets/simple-and-fast/crea-personaggio.webp",
      "/assets/simple-and-fast/scheda.webp",
      "/assets/simple-and-fast/combat.webp",
      "/assets/simple-and-fast/feed.webp",
    ],
    intro: {
      it: "Simple and Fast non è un semplice supporto: è il mio gioco di ruolo originale racchiuso in un'app — un intero GdR in tasca. Uscirà prima su App Store, gratuita per i giocatori. I Master, con un unico acquisto da 9,99 €, sbloccano il regolamento completo, decine di scenari pronti da giocare e gli strumenti per gestire sessioni, indizi e tiri di dado.",
      en: "Simple and Fast is not just a companion: it's my original tabletop RPG packed into an app — a whole RPG in your pocket. It launches first on the App Store, free for players. Masters, with a single €9.99 purchase, unlock the full ruleset, dozens of ready-to-play scenarios, and tools to run sessions, clues and dice rolls.",
    },
    intro2: {
      it: "Simple and Fast nasce da anni di sessioni al tavolo: volevo un regolamento che si spiega in cinque minuti e si gioca per ore. Niente manuali da cento pagine, niente preparazione infinita: il Master apre l'app, sceglie uno scenario pronto e la sessione parte. I giocatori creano il loro eroe in pochi secondi e si uniscono alla stanza con un codice o un QR. Dietro la semplicità c'è un sistema completo: caratteristiche, sfere fisica e mentale, dadi da d4 a d100, iniziativa, danni e indizi da distribuire al gruppo. Tutto sincronizzato in tempo reale, tutto pensato per lasciare spazio alla storia.",
      en: "Simple and Fast was born from years of sessions at the table: I wanted a ruleset you explain in five minutes and play for hours. No hundred-page manuals, no endless prep: the Master opens the app, picks a ready scenario and the session starts. Players create their hero in seconds and join the room with a code or QR. Behind the simplicity lies a complete system: characteristics, physical and mental spheres, d4 to d100 dice, initiative, damage and clues to hand out to the group. Everything synced in real time, everything designed to leave room for the story.",
    },
    details: {
      it: [
        "Il regolamento è pensato per chi non ha mai giocato di ruolo: poche regole chiare, dadi da d4 a d100 e un sistema di sfere Fisica e Mentale che copre ogni situazione senza tabelle infinite. Se sai raccontare una storia, sai già giocare.",
        "Il Master gestisce tutto dall'app: assegna gli indizi ai giocatori, tira i dadi, tiene traccia dei personaggi non giocanti e consulta il regolamento completo senza mai staccare gli occhi dal tavolo. Gli scenari inclusi coprono investigazione, azione e mistero, pronti da giocare senza preparazione.",
        "E gli scenari non finiscono mai: oltre a quelli inclusi, potrai scaricarne di nuovi direttamente dal server, completi di immagini, testi, trama, PNG e nemici già pronti da giocare. E se hai un'idea tutta tua, puoi creare scenari personalizzati direttamente dall'app e condividerli con il tuo gruppo.",
      ],
      en: [
        "The ruleset is designed for people who have never played a tabletop RPG: a few clear rules, d4 to d100 dice and a Physical and Mental spheres system that covers every situation without endless tables. If you can tell a story, you already know how to play.",
        "The Master runs everything from the app: hand out clues to players, roll dice, track non-player characters and consult the full ruleset without ever taking your eyes off the table. The included scenarios cover investigation, action and mystery, ready to play with zero preparation.",
        "And the scenarios never run out: besides the included ones, you'll be able to download new ones straight from the server, complete with images, texts, plot, NPCs and ready-to-play enemies. And if you have your own idea, you can create custom scenarios right in the app and share them with your group.",
      ],
    },
    features: [
      {
        title: { it: "Un intero GdR in un'app", en: "A whole RPG in one app" },
        items: {
          it: ["Regolamento originale, pensato per essere semplice e veloce", "Crea eroi in pochi secondi: nome, professione e descrizione", "Due sfere — Fisica e Mentale — con budget di punti 100/80/60", "Forza, Resistenza, Agilità, Intelligenza, Percezione, Istruzione", "Esperienza e XP per far crescere il personaggio"],
          en: ["Original ruleset, designed to be simple and fast", "Create heroes in seconds: name, occupation and description", "Two spheres — Physical and Mental — with 100/80/60 point budgets", "Strength, Endurance, Agility, Intelligence, Perception, Education", "Experience and XP to grow your character"],
        },
      },
      {
        title: { it: "Gratis per i giocatori", en: "Free for players" },
        items: {
          it: ["I giocatori creano il personaggio e giocano senza pagare nulla", "Ci si unisce alla stanza con codice o QR", "Feed condiviso e note rapide del gruppo in tempo reale"],
          en: ["Players create their character and play without paying anything", "Join the room with a code or QR", "Shared feed and quick group notes in real time"],
        },
      },
      {
        title: { it: "Sblocco Master — 9,99 €", en: "Master unlock — €9.99" },
        items: {
          it: ["Regolamento completo sbloccato", "Decine di scenari pronti per essere giocati", "Gestione delle sessioni e degli indizi", "Tiri di dado d4–d100 con iniziativa e combattimento"],
          en: ["Full ruleset unlocked", "Dozens of ready-to-play scenarios", "Session and clue management", "d4–d100 dice rolls with initiative and combat"],
        },
      },
      {
        title: { it: "E in più", en: "Plus" },
        items: {
          it: ["Accesso opzionale con Google o Apple", "Backup su cloud opzionale", "Salva il log completo della partita"],
          en: ["Optional Google or Apple sign-in", "Optional cloud backup", "Save the full session log"],
        },
      },
    ],
    changelog: null,
    roadmap: {
      it: ["Lancio su App Store", "Poi Google Play", "Nuovi scenari dopo il lancio"],
      en: ["App Store launch", "Google Play next", "New scenarios after launch"],
    },
  },
  {
    slug: "dpt-diario-pressione-terapia",
    name: "DPT Diario Pressione e Terapia",
    category: { it: "Medicina", en: "Medical" },
    tagline: { it: "Pressione, pasti e terapia in un unico diario", en: "Blood pressure, meals and therapy in one diary" },
    accent: "#22D3EE",
    version: "1.1.2",
    size: "15,8 MB",
    age: "4+",
    price: { it: "Gratis", en: "Free" },
    storeUrl: "https://apps.apple.com/it/app/dpt-diario-pressione-e-terapia/id6816541148",
    comingSoon: false,
    appleOnly: true,
    icon: "/assets/dpt/icon.webp",
    banner: "/assets/dpt/banner.webp",
    screenshots: [
      "/assets/dpt/shot-01.webp",
      "/assets/dpt/shot-02.webp",
      "/assets/dpt/shot-03.webp",
      "/assets/dpt/shot-04.webp",
      "/assets/dpt/shot-05.webp",
      "/assets/dpt/shot-06.webp",
      "/assets/dpt/shot-07.webp",
      "/assets/dpt/shot-08.webp",
      "/assets/dpt/shot-09.webp",
      "/assets/dpt/shot-10.webp",
    ],
    intro: {
      it: "DPT Diario Pressione e Terapia ti aiuta a registrare e consultare pressione arteriosa, battito, pasti e terapia in un unico diario semplice e ordinato. Registra pressione e battito, rispetta i tempi dopo i pasti, segui la terapia e consulta grafici chiari. Anche su Apple Watch, con integrazione Apple Salute.",
      en: "DPT Diario Pressione e Terapia helps you record and review blood pressure, heart rate, meals and therapy in one simple, tidy diary. Log pressure and heart rate, respect post-meal timing, follow your therapy and check clear charts. Also on Apple Watch, with Apple Health integration.",
    },
    features: [
      {
        title: { it: "Il diario", en: "The diary" },
        items: {
          it: ["Registra pressione sistolica, diastolica e frequenza cardiaca", "Seconda misurazione ricordata dopo 5 minuti, con media automatica delle misure ravvicinate", "Grafici chiari: i colori distinguono valori bassi, nella norma, da osservare o elevati", "Andamento su 1, 7, 14 o 28 giorni", "Orari dei pasti: l'app ti dice quando sono trascorsi 60 minuti prima di una nuova misurazione"],
          en: ["Record systolic and diastolic pressure and heart rate", "Second measurement reminder after 5 minutes, with automatic average of close readings", "Clear charts: colours distinguish low, normal, watch and high values", "Trends over 1, 7, 14 or 28 days", "Meal times: the app tells you when 60 minutes have passed before a new measurement"],
        },
      },
      {
        title: { it: "Terapia e promemoria", en: "Therapy and reminders" },
        items: {
          it: ["Nome, dosaggio e orario di ogni medicinale", "Promemoria giornalieri con notifiche locali", "Conferma di assunzione, con indicatori visibili sul grafico", "Ricorrenze flessibili: ogni giorno, a giorni alterni o personalizzate"],
          en: ["Name, dosage and time for each medication", "Daily reminders with local notifications", "Intake confirmation, with markers visible on the chart", "Flexible recurrence: daily, alternate days or custom"],
        },
      },
      {
        title: { it: "Salute, Watch e PDF", en: "Health, Watch and PDF" },
        items: {
          it: ["Legge e salva pressione e battito in Apple Salute, solo con il tuo consenso", "Consulta e registra rapidamente da Apple Watch", "Esporta un rapporto PDF da conservare o condividere con il medico", "I dati restano sul dispositivo: niente pubblicità, marketing o profilazione"],
          en: ["Reads and saves pressure and heart rate to Apple Health, only with your consent", "Review and record quickly from Apple Watch", "Export a PDF report to keep or share with your doctor", "Data stays on your device: no ads, marketing or profiling"],
        },
      },
    ],
    details: {
      it: [
        "DPT nasce per chi deve tenere la pressione sotto controllo ogni giorno: due misurazioni ravvicinate con media automatica rendono il diario più attendibile, e i colori dei grafici fanno capire a colpo d'occhio come sta andando.",
        "Cambiare iPhone non fa perdere la storia: con il tuo consenso pressione e battito si recuperano da Apple Salute, mentre un archivio esportabile ripristina pasti, terapia, assunzioni, note e preferenze.",
        "DPT è uno strumento di registrazione personale: non sostituisce il medico, non formula diagnosi e non deve essere usato per modificare autonomamente una terapia.",
      ],
      en: [
        "DPT was built for people who need to monitor their blood pressure every day: two close readings with an automatic average make the diary more reliable, and the chart colours show at a glance how things are going.",
        "Switching iPhone doesn't mean losing your history: with your consent, pressure and heart rate are recovered from Apple Health, while an exportable archive restores meals, therapy, intakes, notes and preferences.",
        "DPT is a personal recording tool: it does not replace a doctor, does not provide diagnoses and must not be used to change a therapy on your own.",
      ],
    },
    changelog: {
      version: "1.1.2",
      it: ["Gestione migliorata delle conferme della terapia quando si salta un'assunzione"],
      en: ["Improved therapy-confirmation handling when an intake is skipped"],
    },
    roadmap: {
      it: ["Nuove statistiche e report per il medico", "Miglioramenti continui all'esperienza su Apple Watch"],
      en: ["New statistics and reports for your doctor", "Ongoing improvements to the Apple Watch experience"],
    },
  },
  {
    slug: "lampo-reader",
    name: "Lampo Reader",
    family: "lampo",
    category: { it: "Lettura rapida", en: "Speed Reading" },
    tagline: { it: "Una parola alla volta, alla tua velocità.", en: "One word at a time, at your own pace." },
    accent: "#4D9FFF",
    version: "1.1",
    size: "3,8 MB",
    age: "4+",
    price: { it: "Gratis", en: "Free" },
    storeUrl: "https://apps.apple.com/it/app/lampo-reader/id6811564778",
    comingSoon: false,
    icon: "/assets/lampo-reader/icon.webp",
    banner: "/assets/lampo-reader/banner.webp",
    screenshots: [
      "/assets/lampo-reader/shot-01.webp",
      "/assets/lampo-reader/shot-02.webp",
      "/assets/lampo-reader/shot-03.webp",
      "/assets/lampo-reader/shot-04.webp",
      "/assets/lampo-reader/shot-05.webp",
      "/assets/lampo-reader/shot-06.webp",
      "/assets/lampo-reader/shot-07.webp",
      "/assets/lampo-reader/shot-08.webp",
      "/assets/lampo-reader/shot-09.webp",
      "/assets/lampo-reader/shot-10.webp",
    ],
    intro: {
      it: "Lampo Reader è un'app di lettura rapida: leggi i tuoi testi una o più parole alla volta, alla velocità che scegli tu. Incolla un testo, importa un file TXT o PDF oppure cerca sul web — e allena la lettura al tuo ritmo. Nativa per iPhone e iPad, in arrivo su Mac e Android, completamente gratuita e senza pubblicità.",
      en: "Lampo Reader is a speed-reading app: read your texts one or more words at a time, at the pace you choose. Paste some text, import a TXT or PDF file, or search the web — and train your reading at your own rhythm. Native for iPhone and iPad, coming soon to Mac and Android, completely free with no ads.",
    },
    features: [
      {
        title: { it: "Come funziona", en: "How it works" },
        items: {
          it: ["Incolla un testo o importa file TXT e PDF", "Cerca sul web e leggi le pagine direttamente nell'app", "Leggi una o più parole alla volta, alla tua velocità", "La posizione di lettura si salva da sola: riprendi dove eri rimasto"],
          en: ["Paste text or import TXT and PDF files", "Search the web and read pages right inside the app", "Read one or more words at a time, at your own speed", "Your reading position saves itself: pick up where you left off"],
        },
      },
      {
        title: { it: "A modo tuo", en: "Your way" },
        items: {
          it: ["Velocità di lettura regolabile", "Font, dimensione del testo e tema personalizzabili", "Scegli quante parole vedere alla volta", "Modalità di lettura multiple"],
          en: ["Adjustable reading speed", "Customisable font, text size and theme", "Choose how many words to show at once", "Multiple reading modes"],
        },
      },
      {
        title: { it: "Pensata per tutti", en: "Made for everyone" },
        items: {
          it: ["Utile per allenare la lettura, anche per persone con dislessia (font OpenDyslexic incluso)", "Controllo genitori con PIN per bloccare le funzioni web", "Nessun account, nessuna pubblicità, nessun tracciamento", "Tutto resta sul tuo dispositivo", "Completamente gratuita"],
          en: ["Great for reading training, including people with dyslexia (OpenDyslexic font included)", "Parental control with PIN to lock web features", "No account, no ads, no tracking", "Everything stays on your device", "Completely free"],
        },
      },
    ],
    details: {
      it: [
        "Leggere velocemente è un'abilità che si allena, e Lampo Reader è la palestra: mostrando una o più parole alla volta a velocità crescente, elimina il vagabondare dell'occhio sulla riga e abitua la mente a riconoscere le parole all'istante.",
        "È pensata anche per chi trova la lettura faticosa, come le persone con dislessia: font e spaziature regolabili, ritmo personalizzabile e poche parole alla volta rendono la lettura più accessibile e meno stancante.",
      ],
      en: [
        "Fast reading is a trainable skill, and Lampo Reader is the gym: by showing one or a few words at a time at increasing speed, it stops your eyes from wandering across the line and trains your mind to recognise words instantly.",
        "It's also designed for people who find reading tiring, such as people with dyslexia: adjustable fonts and spacing, a customisable pace and just a few words at a time make reading more accessible and less exhausting.",
      ],
    },
    changelog: {
      version: "1.1",
      it: ["Domande sulla comprensione del testo al termine della lettura, su dispositivi con Apple Intelligence"],
      en: ["Text-comprehension questions at the end of each reading, on Apple Intelligence devices"],
    },
    roadmap: {
      it: ["Versione Mac (Intel e Apple Silicon)", "Versione Android", "Nuove modalità di allenamento"],
      en: ["Mac version (Intel and Apple Silicon)", "Android version", "New training modes"],
    },
  },
  {
    slug: "lampo-memory",
    name: "Lampo Memory",
    family: "lampo",
    category: { it: "Mnemotecniche", en: "Memory Techniques" },
    tagline: { it: "Tecniche mnemoniche per tutti.", en: "Memory techniques for everyone." },
    accent: "#D946EF",
    version: null,
    size: null,
    age: null,
    price: null,
    storeUrl: null,
    comingSoon: true,
    appleOnly: true,
    icon: "/assets/lampo-memory/icon.webp",
    banner: "/assets/lampo-memory/banner.webp",
    screenshots: [
      "/assets/lampo-memory/esercizi.webp",
      "/assets/lampo-memory/schede.webp",
      "/assets/lampo-memory/storia.webp",
      "/assets/lampo-memory/pao.webp",
      "/assets/lampo-memory/tutorial.webp",
    ],
    intro: {
      it: "Lampo Memory ti insegna a ricordare qualsiasi cosa: esercizi guidati e spiegazioni chiare sulla conversione fonetica e sulle grandi tecniche mnemoniche, dallo Schedario Mnemonico al sistema PAO. In arrivo per iPhone, iPad e Mac.",
      en: "Lampo Memory teaches you to remember anything: guided exercises and clear explanations of phonetic conversion and the great mnemonic techniques, from the Mnemonic Filing System to the PAO system. Coming soon for iPhone, iPad and Mac.",
    },
    features: [
      {
        title: { it: "Impara le tecniche", en: "Learn the techniques" },
        items: {
          it: ["Conversione fonetica: trasforma i numeri in parole indimenticabili", "Schedario Mnemonico e metodo dei Loci", "Sistema PAO: Persona, Azione, Oggetto", "Spiegazioni passo passo con esempi e fonti storiche"],
          en: ["Phonetic conversion: turn numbers into unforgettable words", "Mnemonic Filing System and the method of loci", "PAO system: Person, Action, Object", "Step-by-step explanations with examples and historical sources"],
        },
      },
      {
        title: { it: "Allena la mente", en: "Train your mind" },
        items: {
          it: ["Esercizi guidati con progressi salvati sul dispositivo", "Associazioni mnemoniche personalizzate", "Usa le tue immagini o creale con Image Playground", "Schedari mentali, loci e liste PAO costruiti da te"],
          en: ["Guided exercises with progress saved on your device", "Custom mnemonic associations", "Use your own images or create them with Image Playground", "Mental card files, loci and PAO lists built by you"],
        },
      },
      {
        title: { it: "Per tutti", en: "For everyone" },
        items: {
          it: ["Spiegazioni semplici, anche per chi parte da zero", "Video tutorial integrati", "Nessun account, nessuna pubblicità, nessun tracciamento", "Tutto resta sul tuo dispositivo"],
          en: ["Simple explanations, even for complete beginners", "Built-in tutorial videos", "No account, no ads, no tracking", "Everything stays on your device"],
        },
      },
    ],
    details: {
      it: [
        "La conversione fonetica è il segreto dei campioni di memoria: ogni cifra diventa un suono, ogni numero una parola, ogni parola un'immagine. Lampo Memory te la insegna con esercizi pratici finché non diventa automatica — e da lì, ricordare numeri lunghi, date ed elenchi smette di sembrare un superpotere.",
        "Le tecniche funzionano meglio quando sono tue: per questo puoi sostituire le immagini delle schede con le tue foto, personalizzare personaggi, azioni e oggetti del tuo sistema PAO e costruire il tuo Schedario Mnemonico pezzo per pezzo. Tutto resta sul dispositivo, senza account né cloud.",
      ],
      en: [
        "Phonetic conversion is the secret of memory champions: every digit becomes a sound, every number a word, every word an image. Lampo Memory teaches it with practical exercises until it becomes automatic — and from there, remembering long numbers, dates and lists stops looking like a superpower.",
        "Techniques work best when they're yours: that's why you can replace card images with your own photos, personalise the characters, actions and objects of your PAO system and build your Mnemonic Filing System piece by piece. Everything stays on your device, with no account and no cloud.",
      ],
    },
    changelog: null,
    roadmap: {
      it: ["Lancio su App Store per iPhone, iPad e Mac", "Video tutorial integrati", "Nuovi esercizi e tecniche"],
      en: ["App Store launch for iPhone, iPad and Mac", "Built-in tutorial videos", "New exercises and techniques"],
    },
  },
  {
    slug: "lampo-magic",
    name: "Lampo Magic",
    family: "lampo",
    category: { it: "Magia", en: "Magic" },
    tagline: { it: "Effetti di magia spiegati passo passo", en: "Magic effects explained step by step" },
    accent: "#E11D48",
    version: null,
    size: null,
    age: null,
    price: { it: "Gratis · Acquisti in-app", en: "Free · In-App Purchases" },
    storeUrl: null,
    comingSoon: true,
    appleOnly: true,
    icon: "/assets/lampo-magic/icon.webp",
    banner: "/assets/lampo-magic/banner.webp",
    screenshots: [],
    intro: {
      it: "Lampo Magic porta la magia sul tuo iPhone: effetti pronti da eseguire subito, spiegati gesto dopo gesto. Inizi gratis con gli effetti inclusi e, quando vuoi salire di livello, sblocchi i tre effetti professionali di Fabio: Parole in Treno, Numb3rs T3l3pathy e Magic Square. E se vuoi allenare la memoria, il collegamento a Lampo Memory ti insegna uno stack di carte completo.",
      en: "Lampo Magic brings magic to your iPhone: ready-to-perform effects, explained move by move. Start free with the included effects and, when you're ready to level up, unlock Fabio's three professional effects: Parole in Treno, Numb3rs T3l3pathy and Magic Square. And if you want to train your memory, the link to Lampo Memory teaches you a full card stack.",
    },
    features: [
      {
        title: { it: "Inizi gratis", en: "Start free" },
        items: {
          it: ["Effetti di magia gratuiti, pronti da eseguire subito", "Tutorial video che ti guidano passo passo", "Presentazioni dal vivo degli effetti su YouTube", "Impara a memoria uno stack di carte con il collegamento a Lampo Memory"],
          en: ["Free magic effects, ready to perform right away", "Video tutorials that guide you step by step", "Live presentations of the effects on YouTube", "Memorise a full card stack with the link to Lampo Memory"],
        },
      },
      {
        title: { it: "Gli effetti professionali", en: "The professional effects" },
        items: {
          it: ["Parole in Treno — il mentalismo con le parole, disponibile anche su Hyde Official Store", "Numb3rs T3l3pathy — numeri e telepatia, in esclusiva su Lampo Magic", "Magic Square — il laboratorio di matrici e quadrati magici personalizzabili"],
          en: ["Parole in Treno — word mentalism, also available on the Hyde Official Store", "Numb3rs T3l3pathy — numbers and telepathy, exclusive to Lampo Magic", "Magic Square — the workshop for customisable magic square matrices"],
        },
      },
      {
        title: { it: "Gli strumenti", en: "The tools" },
        items: {
          it: ["Magic Square: crea quadrati magici personalizzati per qualsiasi numero", "Stampa le tue creazioni direttamente dall'app", "Magic Square anche al polso, con la connessione ad Apple Watch", "Tutorial sempre aggiornati, ospitati su un server dedicato"],
          en: ["Magic Square: create custom magic squares for any number", "Print your creations straight from the app", "Magic Square on your wrist too, with the Apple Watch connection", "Always up-to-date tutorials, hosted on a dedicated server"],
        },
      },
    ],
    details: {
      it: [
        "La magia è condivisione: per questo Lampo Magic si inizia gratis. I primi effetti ti fanno provare subito l'emozione di stupire, e i tutorial video ti accompagnano gesto dopo gesto, come a una lezione privata.",
        "Quando sei pronto per il livello successivo, i tre effetti professionali sono quelli che Fabio esegue davvero: Parole in Treno, il suo effetto di mentalismo pubblicato anche da Hyde; Numb3rs T3l3pathy, un esperimento di telepatia numerica in esclusiva qui; e Magic Square, con un vero laboratorio per creare quadrati magici personalizzati da stampare o consultare al polso.",
      ],
      en: [
        "Magic is sharing: that's why Lampo Magic starts free. The first effects let you experience the thrill of amazing people right away, and the video tutorials walk you through move by move, like a private lesson.",
        "When you're ready for the next level, the three professional effects are the ones Fabio actually performs: Parole in Treno, his mentalism effect also published by Hyde; Numb3rs T3l3pathy, an experiment in numerical telepathy exclusive here; and Magic Square, with a real workshop for creating custom magic squares to print or check on your wrist.",
      ],
    },
    changelog: null,
    roadmap: {
      it: ["Lancio su App Store per iPhone", "Nuovi effetti gratuiti nel tempo"],
      en: ["App Store launch for iPhone", "New free effects over time"],
    },
  },
  {
    slug: "cat-reversi",
    name: "Cat Reversi",
    category: { it: "Giochi da tavolo", en: "Board Games" },
    tagline: { it: "Strategia, gattini e scatole", en: "Strategy, kittens and boxes" },
    accent: "#F97316",
    version: null,
    size: null,
    age: null,
    price: { it: "Gratis · Acquisti in-app", en: "Free · In-App Purchases" },
    storeUrl: null,
    comingSoon: true,
    icon: "/assets/cat-reversi/icon.webp",
    banner: "/assets/cat-reversi/banner.webp",
    screenshots: [],
    intro: {
      it: "Cat Reversi è il classico Reversi (Othello) come non lo hai mai visto: al posto delle pedine, gattini bianchi e neri che si acciambellano dentro le scatole della scacchiera. Circonda i gatti avversari per conquistarli, in partite 1 contro 1, contro una CPU che impara da te o in puzzle sempre più insidiosi. In arrivo per iPhone, iPad e Mac, e più avanti su Android.",
      en: "Cat Reversi is the classic Reversi (Othello) like you've never seen it: instead of discs, white and black kittens curling up inside the board's boxes. Surround your opponent's cats to win them over, in 1-vs-1 matches, against a CPU that learns from you, or in ever-trickier puzzles. Coming soon for iPhone, iPad and Mac, and later on Android.",
    },
    features: [
      {
        title: { it: "Tre modi di giocare", en: "Three ways to play" },
        items: {
          it: ["1 contro 1 sullo stesso dispositivo, per sfidare chi hai accanto", "Contro la CPU: 3 livelli di difficoltà adattivi, che crescono con i tuoi risultati", "Modalità puzzle: partite già iniziate da ribaltare, sempre più difficili", "Regole classiche del Reversi, facili da imparare e profonde da padroneggiare"],
          en: ["1 vs 1 on the same device, to challenge whoever's next to you", "Against the CPU: 3 adaptive difficulty levels that grow with your results", "Puzzle mode: games already in progress to turn around, harder and harder", "Classic Reversi rules, easy to learn and deep to master"],
        },
      },
      {
        title: { it: "Multiplayer", en: "Multiplayer" },
        items: {
          it: ["Partite online con Game Center: abbinamento e turni asincroni", "Multiplayer in rete locale: un dispositivo ospita la partita, l'altro si unisce", "Nessun account da creare presso lo sviluppatore"],
          en: ["Online matches with Game Center: matchmaking and asynchronous turns", "Local-network multiplayer: one device hosts the match, the other joins", "No account to create with the developer"],
        },
      },
      {
        title: { it: "Gatti e scatole", en: "Cats and boxes" },
        items: {
          it: ["Gattini bianchi e neri si contendono le scatole della scacchiera", "Ogni mossa conquistata trasforma i gatti avversari nei tuoi", "Importa la tua musica e i tuoi effetti sonori per un'atmosfera su misura", "Gratis, con un acquisto unico per rimuovere la pubblicità"],
          en: ["White and black kittens compete for the board's boxes", "Every winning move turns the opponent's cats into yours", "Import your own music and sound effects for a tailor-made atmosphere", "Free, with a one-time purchase to remove ads"],
        },
      },
    ],
    details: {
      it: [
        "Il Reversi è un gioco di strategia perfetto da insegnare in trenta secondi: ogni mossa può ribaltare l'intera scacchiera. In Cat Reversi quella tensione diventa tenera: le pedine sono gattini che si accomodano nelle scatole, e conquistare una fila significa vederli cambiare colore.",
        "La CPU adatta la sua forza ai tuoi risultati, così ogni partita resta combattuta; i puzzle partono da posizioni già iniziate e ti chiedono la mossa giusta; e quando vuoi una sfida vera, puoi giocare online con Game Center o in rete locale con chi è nella tua stessa stanza.",
      ],
      en: [
        "Reversi is a strategy game you can teach in thirty seconds: every move can flip the entire board. In Cat Reversi that tension turns tender: the discs are kittens settling into boxes, and claiming a row means watching them change colour.",
        "The CPU adapts its strength to your results, so every match stays close; the puzzles start from games already in progress and ask you for the right move; and when you want a real challenge, you can play online with Game Center or over the local network with someone in the same room.",
      ],
    },
    changelog: null,
    roadmap: {
      it: ["Lancio su App Store per iPhone, iPad e Mac", "Versione Android su Google Play", "Nuovi puzzle e nuove scatole a tema"],
      en: ["App Store launch for iPhone, iPad and Mac", "Android version on Google Play", "New puzzles and new themed boxes"],
    },
  },
  {
    slug: "slide-and-solve",
    name: "Slide & Solve",
    category: { it: "Puzzle", en: "Puzzle" },
    tagline: { it: "Un puzzle semplice che ti cattura", en: "A simple puzzle that hooks you" },
    accent: "#38BDF8",
    version: null,
    size: null,
    age: null,
    price: { it: "Gratis · Acquisti in-app", en: "Free · In-App Purchases" },
    storeUrl: null,
    comingSoon: true,
    icon: "/assets/slide-and-solve/icon.webp",
    banner: "/assets/slide-and-solve/banner.webp",
    screenshots: [],
    intro: {
      it: "Slide & Solve è un puzzle di logica pura: ogni tessera porta un numero e si muove esattamente di tante caselle. Scivola, rimbalza, pianifica — e porta ogni tessera sul suo obiettivo. Una regola sola, centinaia di soluzioni possibili. In arrivo per iPhone, iPad e Mac, e più avanti su Android.",
      en: "Slide & Solve is pure logic puzzling: every tile carries a number and moves exactly that many squares. Slide, bounce, plan — and bring every tile onto its goal. One single rule, hundreds of possible solutions. Coming soon for iPhone, iPad and Mac, and later on Android.",
    },
    features: [
      {
        title: { it: "Il gioco", en: "The game" },
        items: {
          it: ["Ogni tessera ha un numero: si muove esattamente di tante caselle alla volta", "Porta tutte le tessere sugli obiettivi per risolvere il livello", "Una regola sola da imparare, sfide sempre più profonde", "Perfetto per due minuti o per un'ora intera"],
          en: ["Every tile has a number: it moves exactly that many squares at a time", "Bring all the tiles onto their goals to solve the level", "One single rule to learn, ever-deeper challenges", "Perfect for two minutes or a whole hour"],
        },
      },
      {
        title: { it: "Le modalità", en: "The modes" },
        items: {
          it: ["Modalità libera: gioca senza vincoli e trova il tuo ritmo", "Livelli puzzle sempre più impegnativi, uno dopo l'altro", "Condividi le tue mosse con un amico e sfidalo a fare meglio", "Multiplayer e obiettivi con Apple Game Center"],
          en: ["Free mode: play with no constraints and find your rhythm", "Puzzle levels that get more demanding, one after another", "Share your moves with a friend and challenge them to do better", "Multiplayer and achievements with Apple Game Center"],
        },
      },
      {
        title: { it: "Senza pensieri", en: "No strings" },
        items: {
          it: ["Nessun account da creare: apri e giochi", "I progressi restano sul tuo dispositivo", "Gratis, con un acquisto unico per rimuovere la pubblicità per sempre"],
          en: ["No account to create: open and play", "Your progress stays on your device", "Free, with a one-time purchase to remove ads forever"],
        },
      },
    ],
    details: {
      it: [
        "Basta una partita per capire tutto: la tessera col 3 scivola di tre caselle, quella col 5 di cinque. Ma quando le tessere si contendono le stesse corsie e gli obiettivi sembrano a un passo, ogni mossa diventa una piccola scelta strategica.",
        "Slide & Solve nasce per catturarti con gentilezza: niente timer ansiosi, niente account, niente fronzoli. Solo tu, le tessere sorridenti e quel livello che 'stavolta lo risolvo'.",
      ],
      en: [
        "One match is enough to learn everything: the tile with 3 slides three squares, the one with 5 slides five. But when tiles compete for the same lanes and the goals seem one step away, every move becomes a little strategic choice.",
        "Slide & Solve was made to hook you gently: no anxious timers, no accounts, no frills. Just you, the smiling tiles and that level you'll solve 'this time for sure'.",
      ],
    },
    changelog: null,
    roadmap: {
      it: ["Lancio su App Store per iPhone, iPad e Mac", "Versione Android su Google Play", "Nuovi livelli puzzle e sfide quotidiane"],
      en: ["App Store launch for iPhone, iPad and Mac", "Android version on Google Play", "New puzzle levels and daily challenges"],
    },
  },
  {
    slug: "lampo-store-server",
    name: "Lampo Store Server",
    family: "lampo-store",
    category: { it: "Gestionale", en: "Business" },
    tagline: { it: "Il cuore del tuo gestionale", en: "The heart of your retail system" },
    accent: "#94A3B8",
    version: null,
    size: null,
    age: null,
    price: { it: "A pagamento", en: "Paid" },
    storeUrl: null,
    comingSoon: true,
    appleOnly: true,
    icon: "/assets/lampo-store-server/icon.webp",
    banner: "/assets/lampo-store-server/banner.webp",
    screenshots: [],
    intro: {
      it: "Lampo Store Server si installa su un Mac del tuo negozio e diventa il cuore di tutto il sistema: è lui a custodire il database e a coordinare vendite, carichi, cambi merce, ordini e documenti. L'amministratore può collegare quanti punti accesso desidera con le app Lampo Store, gratuite. Nasce da un'esperienza ventennale su gestionali su misura per negozi di abbigliamento, già al lavoro in diversi negozi a Roma.",
      en: "Lampo Store Server installs on a Mac in your shop and becomes the heart of the whole system: it holds the database and coordinates sales, stock intake, exchanges, orders and documents. The administrator can connect as many access points as they like with the free Lampo Store apps. It is born from twenty years of experience with custom management systems for clothing stores, already at work in several shops in Rome.",
    },
    features: [
      {
        title: { it: "Il centro del negozio", en: "The store's core" },
        items: {
          it: ["Si installa su un Mac e custodisce l'intero database del negozio", "Coordina vendita, carico, cambio merce, ordini e documenti commerciali", "L'amministratore collega quanti punti accesso desidera", "I dati restano nel tuo negozio, sotto il tuo controllo"],
          en: ["Installs on a Mac and holds the shop's entire database", "Coordinates sales, stock intake, exchanges, orders and business documents", "The administrator connects as many access points as they like", "Your data stays in your shop, under your control"],
        },
      },
      {
        title: { it: "Vendita e magazzino", en: "Sales and stock" },
        items: {
          it: ["Vendita al banco con scontrini e documenti commerciali", "Carico merce, cambi e verifica delle consegne", "Calcolo di magazzino, sellout e vendite in stock", "Saldi e sconti gestiti in modo flessibile"],
          en: ["Counter sales with receipts and business documents", "Stock intake, exchanges and delivery checks", "Stock calculation, sell-out and in-stock sales", "Sales and discounts managed flexibly"],
        },
      },
      {
        title: { it: "Stampa e integrazioni", en: "Printing and integrations" },
        items: {
          it: ["Stampa di barcode ed etichette tramite il server", "Stampa di documenti commerciali", "Moduli di collegamento a Shopify e WooCommerce", "Per sicurezza, la suite funziona solo su piattaforme Apple"],
          en: ["Barcode and label printing through the server", "Business document printing", "Shopify and WooCommerce connection modules", "For security, the suite runs only on Apple platforms"],
        },
      },
    ],
    details: {
      it: [
        "Prima di diventare un'app, questo sistema è vissuto per vent'anni come gestionale su misura realizzato con Claris FileMaker Pro, scelto e usato ogni giorno da diversi negozi di abbigliamento a Roma. Lampo Store Server porta quell'esperienza in una suite nativa per il mondo Apple.",
        "L'architettura è semplice e solida: un solo Mac fa da server e tiene insieme tutto, mentre i client Lampo Store — gratuiti — girano su iPhone, iPad e Mac per vendere, caricare e consultare. I moduli per Shopify e WooCommerce collegheranno il negozio fisico a quello online.",
      ],
      en: [
        "Before becoming an app, this system lived for twenty years as a custom management solution built with Claris FileMaker Pro, chosen and used every day by several clothing stores in Rome. Lampo Store Server brings that experience into a native suite for the Apple world.",
        "The architecture is simple and solid: a single Mac acts as the server and keeps everything together, while the free Lampo Store clients run on iPhone, iPad and Mac to sell, restock and consult. The Shopify and WooCommerce modules will connect the physical shop to the online one.",
      ],
    },
    changelog: null,
    roadmap: {
      it: ["Lancio su Mac App Store", "Moduli Shopify e WooCommerce", "Nuovi strumenti per l'amministratore"],
      en: ["Mac App Store launch", "Shopify and WooCommerce modules", "New tools for the administrator"],
    },
  },
  {
    slug: "lampo-store",
    name: "Lampo Store",
    family: "lampo-store",
    category: { it: "Gestionale", en: "Business" },
    tagline: { it: "Il gestionale retail per la Moda", en: "The retail management app for Fashion" },
    accent: "#EA580C",
    version: null,
    size: null,
    age: null,
    price: { it: "Gratis · Richiede Lampo Store Server", en: "Free · Requires Lampo Store Server" },
    storeUrl: null,
    comingSoon: true,
    appleOnly: true,
    icon: "/assets/lampo-store/icon.webp",
    banner: "/assets/lampo-store/banner.webp",
    screenshots: [],
    intro: {
      it: "Lampo Store è il client gratuito della suite: gira su iPhone, iPad e Mac e si abbina a Lampo Store Server per lavorare. Vendi al banco, carichi la merce, gestisci ordini e campionari, e con la fotocamera di iPhone e iPad scansioni direttamente i barcode. Più carrelli possono convivere sullo stesso dispositivo, così ogni commesso ha il suo lavoro sempre pronto.",
      en: "Lampo Store is the suite's free client: it runs on iPhone, iPad and Mac and pairs with Lampo Store Server to work. Sell at the counter, load stock, manage orders and sample collections, and use the iPhone and iPad camera to scan barcodes directly. Multiple carts can coexist on the same device, so every assistant's work is always ready.",
    },
    features: [
      {
        title: { it: "Vendita al banco", en: "Counter sales" },
        items: {
          it: ["Vendita veloce con scansione dei barcode dalla fotocamera", "Carrelli multipli sullo stesso dispositivo, uno per cliente", "Cambio merce, saldi, sconti e vendite in stock", "Documenti commerciali stampati tramite il server"],
          en: ["Fast selling with barcode scanning from the camera", "Multiple carts on the same device, one per customer", "Exchanges, sales, discounts and in-stock selling", "Business documents printed through the server"],
        },
      },
      {
        title: { it: "Magazzino e ordini", en: "Stock and orders" },
        items: {
          it: ["Carico merce e verifica delle consegne", "Modulo campionari per creare gli ordini ai fornitori", "Calcolo di magazzino e sellout sempre aggiornati", "Consultazione del catalogo da qualsiasi dispositivo abbinato"],
          en: ["Stock intake and delivery checks", "Sample-collection module to create supplier orders", "Always up-to-date stock calculation and sell-out", "Catalogue browsing from any paired device"],
        },
      },
      {
        title: { it: "Come funziona", en: "How it works" },
        items: {
          it: ["App gratuita: si abbina a Lampo Store Server per lavorare", "Gira su iPhone, iPad e Mac", "L'amministratore autorizza ogni punto accesso dal server", "Per sicurezza, la suite funziona solo su piattaforme Apple"],
          en: ["Free app: it pairs with Lampo Store Server to work", "Runs on iPhone, iPad and Mac", "The administrator authorises every access point from the server", "For security, the suite runs only on Apple platforms"],
        },
      },
    ],
    details: {
      it: [
        "Lampo Store porta il banco vendita in tasca: un iPhone basta per scansionare un capo, aprire un carrello e chiudere una vendita, mentre il Mac con Lampo Store Server tiene tutto sincronizzato e stampa etichette e documenti.",
        "La suite nasce da un gestionale su misura usato da vent'anni in negozi di abbigliamento di Roma: ogni funzione — dai carrelli multipli alla verifica delle consegne — risponde a un'esigenza reale del lavoro quotidiano in negozio.",
      ],
      en: [
        "Lampo Store puts the sales counter in your pocket: an iPhone is enough to scan a garment, open a cart and close a sale, while the Mac running Lampo Store Server keeps everything in sync and prints labels and documents.",
        "The suite is born from a custom management system used for twenty years in Rome clothing stores: every feature — from multiple carts to delivery checks — answers a real need of everyday shop work.",
      ],
    },
    changelog: null,
    roadmap: {
      it: ["Lancio su App Store per iPhone, iPad e Mac", "Moduli Shopify e WooCommerce tramite il server", "Nuove funzioni per il lavoro in negozio"],
      en: ["App Store launch for iPhone, iPad and Mac", "Shopify and WooCommerce modules via the server", "New features for in-store work"],
    },
  },
];

export const getApp = (slug) => APPS.find((a) => a.slug === slug);
